export const LANG_EN_NAME = 'en_CA';

export const LANG_EN_TRANS = {
    'PR.lang': 'en',
    'PR.btn.cancel': 'Cancel',
    'PR.btn.clearfilters': 'Clear all Filters',
    'PR.sortmodal.sort.title': 'Sort products:',
    'PR.sortmodal.sort.sortBy': 'Sort by :',
    'PR.sortmodal.filter.title': 'Filters you have selected:',
    'PR.search.results.title1': 'Search Results For “',
    'PR.search.results.title2': '”',
    'PR.search.sorry.title1': 'WE’RE SORRY',
    'PR.search.sorry.title2': ' We couldn’t find any matches for “',
    'PR.search.sorry.title3': '”, Showing results for “',
    'PR.search.sorry.title4': '”',
    'PR.search.noResult.noMatch1': 'We couldn’t find a match for “',
    'PR.search.noResult.noMatch2': '”',
    'PR.search.noResult.searchAgain': 'Please search again using a different term or browse by brand or category.',
    'PR.results.label.selectedFilters': 'Selected Filters:',
    'PR.results.label.clearFilters': 'Clear all Filters',
    'PR.results.label.showing': 'Showing: ',
    'PR.results.label.items': 'Items',
    'PR.results.label.0results': '0 of 0 Results',
    'PR.results.label.sortBy': 'Sort by :',
    'PR.results.btn.sortfilter': 'Sort & Filter',
    'PR.results.label.perPage': 'Items Per Page:',
    'PR.results.item.or': 'or',
    'PR.results.item.moreChoices': 'More choices available',
    'PR.results.item.freeShipping': 'Free Shipping',
    'PR.results.item.onAir': 'ON AIR NOW',
    'PR.results.itemPrice': 'Price',
    'PR.results.itemFrom': 'From',
    'PR.results.itemOnTsc': 'on TSC.ca\'s',
};


// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../watchuslive/translate/lang-en_CA.ts